import {makeCompletionPattern} from "./factory";
import {IdentTree, PackageDeclarationTree} from "../model";
import {Misc} from "../lexer";
import {Completion} from "@codemirror/autocomplete";

/**
 * package S|
 */
const completePackageName = makeCompletionPattern(
	[PackageDeclarationTree, IdentTree, Misc.identifier] as const,
	(chain, scope, pkgTree, identTree, ident) => {
		const possibilities = ["StudentCode"];
		const result: Completion[] = [];

		for (const possibility of possibilities) {
			if (possibility.startsWith(ident.value)) {
				result.push({label: possibility, type: "package"});
			}
		}

		return {
			from: ident.span.start,
			options: result,
		};
	}
);

export const PACKAGE_COMPLETIONS = [completePackageName];
